import { createSlice } from "@reduxjs/toolkit";

const InitialValue = {
  userLoggedIn: false,
};

const UserStatusSlice = createSlice({
  name: "userStatus",
  initialState: InitialValue,
  reducers: {
    setUserLoginStatus: (state, action) => {
      state.userLoggedIn = action.payload;
    },
  },
});

export const { setUserLoginStatus } = UserStatusSlice.actions;
export default UserStatusSlice.reducer;
